import React, { useState, KeyboardEvent } from "react";
import neutral_girl from "../../assets/images/neutral_girl.webp";
import fight_girl from "../../assets/images/fight_girl.webp";
import defeated_girl from "../../assets/images/defeated_girl.webp";
import neutral_boy from "../../assets/images/neutral_boy.webp";

type ImageGridProps = {
  leftImages?: string[];
  rightImages?: string[];
};

export const ImageGrid = ({
  leftImages = [neutral_girl, fight_girl, defeated_girl],
  rightImages = [neutral_boy],
}: ImageGridProps) => {
  const [leftIndex, setLeftIndex] = useState(0);
  const [rightIndex, setRightIndex] = useState(0);

  const handleLeftClick = () => setLeftIndex((i) => (i + 1) % leftImages.length);
  const handleRightClick = () => setRightIndex((i) => (i + 1) % rightImages.length);

  const handleKey =
    (fn: () => void) =>
    (e: KeyboardEvent<HTMLImageElement>) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        fn();
      }
    };

  const overlap = "35%";
  const containerStyle: React.CSSProperties = {
    display: "grid",
    placeItems: "center",
    width: "100%",
    minHeight: "60vh",
    padding: "2rem 0",
    gridTemplateAreas: `"liv gap stu"`,
    gridTemplateColumns: "minmax(160px,40vw) 4vw minmax(160px,40vw)",
    justifyContent: "center",
    alignItems: "center",
  };

  const baseImageStyle: React.CSSProperties = {
    display: "block",
    width: "100%",
    height: "auto",
    borderRadius: "10px",
    objectFit: "cover",
    transition: "transform 200ms ease, box-shadow 200ms ease",
    cursor: "pointer",
  };

  const leftStyle: React.CSSProperties = {
    ...baseImageStyle,
    gridArea: "liv",
    transform: `translateX(${overlap})`,
    zIndex: 2,
  };

  const rightStyle: React.CSSProperties = {
    ...baseImageStyle,
    gridArea: "stu",
    transform: `translateX(-${overlap})`,
    zIndex: 1,
  };

  // Provide concise, non-redundant alt text
  const leftAlts = ["Neutral girl", "Fight girl", "Defeated girl"];
  const rightAlts = ["Neutral boy"];

  return (
    <div style={containerStyle}>
      <img
        src={leftImages[leftIndex]}
        alt={leftAlts[leftIndex] ?? "Left character"}
        style={leftStyle}
        onClick={handleLeftClick}
        // role="button"
        tabIndex={0}
        onKeyDown={handleKey(handleLeftClick)}
      />
      <div style={{ gridArea: "gap" }} />
      <img
        src={rightImages[rightIndex]}
        alt={rightAlts[rightIndex] ?? "Right character"}
        style={rightStyle}
        onClick={handleRightClick}
        // role="button"
        tabIndex={0}
        onKeyDown={handleKey(handleRightClick)}
      />
    </div>
  );
};

